<template>
  <section>
    <mov-dropdown
      :disabled="disabled"
      v-model="selectedOption"
      :selectedText="selectedText"
    >
      <b-dropdown-item
        v-for="(stateToShow, index) in statesToShow"
        :key="index"
        :value="stateToShow"
        @click="storeOption"
      >
        {{ $t(`Orders.${stateToShow}`) | upperCase }}
      </b-dropdown-item>
    </mov-dropdown>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import MovDropdown from '@/components/miscellaneous/MovDropdown'

export default {
  name: 'MovimentaDeliveryStateFilter',
  components: {
    MovDropdown
  },
  data () {
    return {
      selectedOption: [],
      disabled: false,
      somethingWrong: false
    }
  },
  computed: {
    ...mapGetters('filters', ['filtersSelected']),
    statesToShow () {
      if (!this.filtersSelected.deliveredEffectiveStatus) return

      return this.filtersSelected.deliveredEffectiveStatus
    },
    selectedText () {
      return this.selectedOption.length > 0 ? this.$t(`Orders.${this.selectedOption}`).toUpperCase() : this.$t('Filters.labelFilterState')
    }
  },
  async mounted () {
    this.$eventBus.$on('cleanFilters', this.callback)
    this.disabled = true

    this.somethingWrong = await this.getDeliveredEffectiveStatus()
    if (!this.somethingWrong) this.disabled = false
  },
  beforeDestroy () {
    this.$eventBus.$off('cleanFilters', this.callback)
  },
  methods: {
    ...mapActions('filters', ['getDeliveredEffectiveStatus', 'setDeliveredEffectiveStatus']),
    storeOption () {
      this.setDeliveredEffectiveStatus(this.selectedOption)
    },
    callback () {
      this.getDeliveredEffectiveStatus()
      this.selectedOption = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/MovimentaDeliveryStateFilter.vue